import script from "./PreferredLender.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreferredLender.vue?vue&type=script&setup=true&lang=ts"

export default script